"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAY_OF_WEEK_POSITION_INDEX = exports.MONTH_POSITION_INDEX = exports.DAY_OF_MONTH_POSITION_INDEX = exports.HOUR_POSITION_INDEX = exports.MINUTE_POSITION_INDEX = void 0;
exports.MINUTE_POSITION_INDEX = 0;
exports.HOUR_POSITION_INDEX = 1;
exports.DAY_OF_MONTH_POSITION_INDEX = 2;
exports.MONTH_POSITION_INDEX = 3;
exports.DAY_OF_WEEK_POSITION_INDEX = 4;
//# sourceMappingURL=const.js.map